import { render, staticRenderFns } from "./WechatPay.vue?vue&type=template&id=02559093&scoped=true&"
import script from "./WechatPay.vue?vue&type=script&lang=js&"
export * from "./WechatPay.vue?vue&type=script&lang=js&"
import style0 from "./WechatPay.vue?vue&type=style&index=0&id=02559093&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02559093",
  null
  
)

export default component.exports